import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface User {
  name: string
  family: string
}

export interface UserResponse {
  user: User
  token: string
}

export interface LoginRequest {
  email: string
  password: string
  captcha?: string
}

export interface ResetRequest {
  email: string
  password: string
  captcha?: string
  code?: string
}

export interface SignupInitRequest {
  email: string
  captcha?: string
  code?: string
}

export interface SignupRequest {
  email: string
  password: string
  repeatPass: string,
  name: string,
  family: string
  captcha?: string
  code?: string
  // Optional referral code from invite link
  ref_code?: string
}

export interface user_status {
  credit: number,
  premium: boolean,
  expire: Date,
}


export interface pendingExams {
  create_date: string,
  Exam: {
    id: number,
    name: string,
  }
}

export interface Dashboard {
  examCountPend: number,
  examCountUndone: number,
  bookmarksCount: number,
  status: user_status,
  pendingExams: [pendingExams],
}

export interface Dashboard {
  sliders: Array<object>,
  faq: Array<object>,
  packages: Array<object>,
  LastBlog: Array<object>,
  comments: Array<object>,
  count: object
}

export interface FAQ {
  id: number
  question: string
  answer: string
}
export interface ContactReq {
  name: string
  email: string
  subject: string
  body: string
}

export interface SettingResponse {
  address: string | null
  about_us: string | null
}

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['auth'],

  endpoints: (builder) => ({
    login: builder.mutation<UserResponse, LoginRequest>({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    getCaptcha: builder.query<{ text: string, data:TrustedHTML }, any>({
      query: () => '/auth/generate_captcha',
      providesTags: ['auth'],
    }),
    signup: builder.mutation<UserResponse, SignupRequest>({
      query: (credentials) => ({
        url: '/auth/signup',
        method: 'POST',
        body: credentials,
      }),
    }),
    signupSendCode: builder.mutation<boolean, SignupInitRequest>({
      query: (credentials) => ({
        url: 'auth/signup/send_code',
        method: 'POST',
        body: credentials,
      }),
    }),
    signupVerify: builder.mutation<boolean, SignupInitRequest>({
      query: (credentials) => ({
        url: 'auth/signup/verify_code',
        method: 'POST',
        body: credentials,
      }),
    }),
    resetSendCode: builder.mutation<boolean, ResetRequest>({
      query: (credentials) => ({
        url: 'auth/reset_password/send_code',
        method: 'POST',
        body: credentials,
      }),
    }),
    resetVerify: builder.mutation<UserResponse, ResetRequest>({
      query: (credentials) => ({
        url: 'auth/reset_password/verify_code',
        method: 'POST',
        body: credentials,
      }),
    }),

    homepage: builder.query<Dashboard, void>({
      query: () => '/panel/home-page',
    }),
    dashboard: builder.query<Dashboard, void>({
      query: () => '/panel/user-dashboard',
    }),
    getFaq: builder.query<FAQ[], void>({
      query: () => '/faq/site',
    }),
    sendContact: builder.mutation<boolean, ContactReq>({
      query: (data) => ({
        url: 'contact',
        method: 'POST',
        body: data,
      }),
    }),
    getSetting: builder.query<SettingResponse, void>({
      query: () => '/setting',
    }),
  }),
})

export const {useLoginMutation, useGetCaptchaQuery , useDashboardQuery, 
  useHomepageQuery, useGetFaqQuery, useSendContactMutation, useSignupMutation,
  useResetSendCodeMutation, useResetVerifyMutation,
   useSignupSendCodeMutation, useSignupVerifyMutation, useGetSettingQuery } = authApi
